import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import config from '../../config';
import { formatMarketingCount } from '../../utils/formatMarketingCount';
import tokenManager from '../../utils/tokenManager';

interface PaymentSuccessProps {
    onUserUpdate?: () => Promise<void>;
    sponsorCount?: number;
}

const PaymentSuccess: React.FC<PaymentSuccessProps> = ({ onUserUpdate, sponsorCount = 134 }) => {
    const [approvedCount, setApprovedCount] = useState(sponsorCount);

    useEffect(() => {
        const refreshSession = async () => {
            const accessToken = await tokenManager.getValidAccessToken();
            if (accessToken && onUserUpdate) {
                await onUserUpdate();
            }
        };
        refreshSession();

        let mounted = true;
        axios.get(`${config.backendUrl}sponsors/db-info`).then(res => {
            if (!mounted) return;
            setApprovedCount(res.data?.sponsors || sponsorCount);
        }).catch(() => {
            if (mounted) setApprovedCount(sponsorCount);
        });

        window.gtag?.('event', 'purchase', {
            currency: 'USD',
            value: 20,
            transaction_id: new URLSearchParams(window.location.search).get('session_id') || Date.now().toString()
        });

        return () => { mounted = false; };
    }, [onUserUpdate, sponsorCount]);

    const sponsorsDisplay = formatMarketingCount(approvedCount);

    return (
        <div className="payment-success-page">
            <div className="payment-success">
                <div className="payment-success__icon" aria-hidden="true">
                    <FontAwesomeIcon icon={faCheckCircle} />
                </div>

                <h1 className="payment-success__title">Welcome to SponsorDB! 🎉</h1>

                <p className="payment-success__subheading">
                    You're subscribed! You now have full access to {sponsorsDisplay} verified sponsors with direct contact info.
                </p>

                <p className="payment-success__thanks">
                    Thank you for trying SponsorDB. We built this for independent newsletter creators like you and we genuinely want to help you land your first sponsor deal.
                </p>

                <p className="payment-success__support">
                    Questions, feedback, or anything at all? Reach us at{' '}
                    <a href="mailto:info@sponsor-db.com">info@sponsor-db.com</a>
                    {' '}— we respond to every email.
                </p>

                <div className="payment-success__actions">
                    <Link to="/sponsors" className="btn btn-primary payment-success__btn">
                        Browse Sponsors
                        <FontAwesomeIcon icon={faArrowRight} className="payment-success__btn-icon" />
                    </Link>
                    <Link to="/profile" className="btn btn-secondary payment-success__btn">
                        View Your Account
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default PaymentSuccess;
